module.exports = __webpack_public_path__ + "img/logo1.9e12be4d.png";